module.exports = __webpack_public_path__ + "static/img/icon07.046795a9.png";